<template>
  <div class="body-width divcss5">
    <div>
      <div class="div-row div-bottom news-Medium-24">
        海大智龙参加2020年中国航海日“带你去航海”科普活动暨帆船邀请赛
        <!-- <span class="news-Regular-14">作者：何舒 来源：科技处 添加时间：2019-05-09 09:13:27</span> -->
      </div>
      <div class="div-text-left news-Regular-14b6">
        <span>2020-07-17</span><span class="div-padding-left">大连海大智龙科技有限公司</span>
      </div>
      <div class="div-line  divcss5"></div>
  
      <div class="div-row div-bottom10">
        <div class=" div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news22/01.png" />
          </div>
        </div>
      </div>
      <div class="div-row div-bottom10">
        <p class="indentation">
         7月11日是第16个中国航海日，为弘扬郑和精神，传承航海文化，宣传普及航海知识，大连海事大学联合中国航海学会共同举办了以“弘扬丝路精神 传承航海文化”为主题的“带你去航海”科普活动暨帆船邀请赛，大连海大智龙科技有限公司受邀参加。本次活动得到了中央电视台的大力支持，通过央视新闻客户端、微博、抖音、头条、B站等平台进行全平台全程直播。
        </p>
        <p class="indentation">
        中国航海学会秘书长闫晓波，大连海事大学党委书记郑少南、校长孙玉清、党委副书记许民强，大连海大智龙科技有限公司董事长尹勇教授、大连名岛帆船俱乐部总经理高林、大连芸衫航海俱乐部总经理许岩、大连拓恩航海俱乐部总经理任秀娟、大洋蓝水帆船俱乐部总经理董小兵等领导和嘉宾出席活动启动仪式。 </p>
     <p class="indentation">
        据了解，本次活动内容包括航海知识科普和帆船邀请赛两大部分。航海知识科普中，大连海事大学相关专业教师向大家详细讲解了帆船运动的历史与发展、帆船竞赛的规则；海大智龙VR游艇驾驶演练系统；无人船相关知识以及无人船领域研究进展；绳结发展历史、绳结分类及应用；六分仪测天定位原理；船上求生信号的辨识，消防逃生知识等内容。此外，还现场演示了驾驶帆船的操作流程等，进行无人艇（蓝信号）航行展示，VR体验顶推、拖带、会遇、救火、营救落水人员等多个场景，现场演示绳结打法并制作绳结工艺品，演示六分仪使用方法以及展示救生衣穿法、救生筏的释放与操作等。 </p>
      </div>
      <div class="div-row div-bottom10">
        <div class=" div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news22/02.png" />
          </div>
        </div>
      </div>
      <div class="div-row div-bottom10">
        <div class=" div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news22/03.png" />
          </div>
        </div>
      </div>
  <div class="div-row div-bottom10">
        <div class=" div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news22/04.png" />
          </div>
        </div>
      </div>
        <div class="div-row div-bottom10">
        <div class=" div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news22/05.png" />
          </div>
        </div>
      </div>

  <div class="div-row div-bottom10">
        <p class="indentation">
        航海是传承人类文明、保护海洋权益、促进商贸交流的保障。2005年7月11日是中国航海家郑和下西洋600周年纪念日。2005年4月25日，经国务院批准，每年7月11日确立为“中国航海日”，作为国家的重要节日，同时也作为“世界海事日”在中国的实施日期。中国航海日”是由政府主导、全民参与的全国性的法定活动日，现已成为我国涉海领域级别高、范围最广、综合性最强的节庆活动。“中国航海日”的确立，有利于弘扬和培育以爱国主义为核心的团结统一、爱好和平、勤劳勇敢、自强不息的伟大民族精神，有利于增强海洋意识和海洋国土观念，形成全社会关心、支持港口航运事业发展的氛围，推动海洋文化、科技和经济发展；有利于普及航海科学知识，形成全社会关心、支持航海事业发展的氛围，形成大力开展航海科研活动的良好风气；有利于向海外宣传中华民族正义、和平、睦邻、友好的优良传统，促进世界和平与共同发展，构建人类海洋命运共同体。
        </p>
  </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {

      };
    },
    methods: {

    },
  };

</script>

<style scoped>
  .fl {
    float: right;
    margin-right: 20px;
  }

  .fy {
    text-align: center;
    margin-top: 30px;
  }

  .title {
    height: 100%;
  }

  .div-width {
    width: 75%;
  }



  .div-line {
    background: #E6E6E6;
    height: 1px;
    width: 100%;

  }

  .div-bottom10 {
    padding-top: 10px;
  }

  .div-bottom30 {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .div-top30 {
    padding-top: 30px;
  }
  img {
    vertical-align: middle;
    border-style: none;
    width: 95%; 
  }
</style>



// WEBPACK FOOTER //
// src/components/contentcoms/news2020/news22.vue